import {combineReducers} from 'redux'
import ModalReducer from './modal'
import MenuReducer from './menu'

const RootReducer = combineReducers({
  ModalReducer,
  MenuReducer,
})

export default RootReducer
